'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'

export interface BrandLogoProps {
  name: string
  className?: string
  grayscale?: boolean
}

/**
 * BrandLogo - Renders a brand logo with optional grayscale effect
 *
 * For Simple Icons integration, import the specific icon and pass as children:
 *
 * @example
 * import { SiGithub } from '@icons-pack/react-simple-icons'
 * <BrandLogo name="github" grayscale>
 *   <SiGithub className="h-8 w-auto" />
 * </BrandLogo>
 */
export function BrandLogo({
  name,
  className,
  grayscale = true,
}: BrandLogoProps & { children?: React.ReactNode }) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        grayscale && 'logo-grayscale',
        className
      )}
      title={name}
    >
      {/*
        Placeholder for brand logos - consumers should either:
        1. Pass children with the actual icon component
        2. Use a custom implementation with @icons-pack/react-simple-icons
        3. Use img tags with logo URLs
      */}
      <span className="text-[var(--landing-text-muted)] text-sm font-medium">
        {name}
      </span>
    </div>
  )
}
